import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Col, Container, Modal, Navbar, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { host } from "../../../utils/APIRoutes";

const KycForm = (props) => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [addressLineOne, setAddressLineOne] = useState("");
  const [addressLineTwo, setAddressLineTwo] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");
  const [userId, setUserId] = useState();
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Beginning form submission");
    const body = {
      firstName: firstName,
      lastName: lastName,
      emailAddress: email,
      phoneNumber: phone,
      address: {
        address1: addressLineOne,
        address2: addressLineTwo,
        city: city,
        state: state,
        postalCode: postalCode,
        isoCountryCode: country,
      },
    };
    console.log("Sending data to finclusive...");
    const { data } = await axios.post(
      `${host}/api/finclusive/createFinclusiveUser/${userId}`,
      body
    );
    // DANGEROUS: bypassing kyc due to finclusive's api key expiring. Before proceeding to prod
    // put the const user .... navigate("/") code block inside data.status === true block
    if (data.status === false) {
      console.error(data.data);
    }
    if (data.status === true) {
      console.log(data);
    }
    const user = JSON.parse(localStorage.getItem("chat-app-current-user"));
    user.hasCompletedKyc = true;
    localStorage.setItem("chat-app-current-user", JSON.stringify(user));
    navigate("/");
    setLoading(true);
  };
  useEffect(() => {
    if (!localStorage.getItem("chat-app-current-user")) {
      navigate("/login");
    }
    setEmail(JSON.parse(localStorage.getItem("chat-app-current-user")).email);
    //console.log(email);
    setUserId(JSON.parse(localStorage.getItem("chat-app-current-user"))._id);
  }, []);
  return (
    <div bg="white">
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand>
            <img src="img/paygold-logo.png" alt="PAYGOLD" />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Form className="bg-white text-dark p-4">
        <Form.Text>
          Before proceeding we require some more information about you. Filling
          this up will allow you to access all the features we have to offer
        </Form.Text>

        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter first name"
                className="bg-white"
                onChange={(e) => setFirstName(e.target.value)}
              />
              {/*<Form.Text className="text-muted">
              We'll never share your email with anyone else
  </Form.Text>*/}
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter last name"
                className="bg-white"
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email ID</Form.Label>
              <Form.Control
                type="email"
                defaultValue={email}
                className="bg-white"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Text className="text-uppercase font-weight-bold">
          Residence Information
        </Form.Text>

        <Form.Group className="mb-3" controlId="addressLineOne">
          <Form.Label>Address Line 1</Form.Label>
          <Form.Control
            type="string"
            placeholder="Enter apartment no. and/or building no."
            className="bg-white"
            onChange={(e) => setAddressLineOne(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="addressLineTwo">
          <Form.Label>Address Line 2</Form.Label>
          <Form.Control
            type="string"
            placeholder="Enter street number"
            className="bg-white"
            onChange={(e) => setAddressLineTwo(e.target.value)}
          />
        </Form.Group>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter city name"
                className="bg-white"
                onChange={(e) => setCity(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="postalCode">
              <Form.Label>ZIP Code</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter zip code"
                className="bg-white"
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="state">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter state"
                className="bg-white"
                onChange={(e) => setState(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="countryCode">
              <Form.Label>ISO Country Code</Form.Label>
              <Form.Control
                type="string"
                placeholder="Enter ISO Country Code"
                className="bg-white"
                onChange={(e) => setCountry(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group classname="mb-3" controlId="checkBox">
          <Form.Check
            type="checkbox"
            label="Agree to Paygold.io's Terms and Conditions"
          />
        </Form.Group>

        {loading ? (
          <Button disabled={true}>Loading...</Button>
        ) : (
          <Button
            variant="primary"
            type="submit"
            onClick={(e) => handleClick(e)}
          >
            Submit
          </Button>
        )}
      </Form>
    </div>
  );
};

export default KycForm;
